import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import FormControl from "@mui/material/FormControl";
import Grid from "@mui/material/Grid";
import MenuItem from "@mui/material/MenuItem";
import Paper from "@mui/material/Paper";
import Select from "@mui/material/Select";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";

// Main table wrapper
export const TableWrapper = styled(Box)(({ theme }) => ({
  padding: 0,
  backgroundColor: "white",
  marginTop: "16px",
  border: "1px solid rgba(54, 49, 87, 0.12)",
  borderRadius: "6px",
}));

// Header row (title + add button)
export const TableHeader = styled(Box)(
  ({ theme, pr = "12px", pl = "24px" }) => ({
    paddingRight: pr,
    paddingLeft: pl,
    backgroundColor: "white",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    height: "59px",
    borderTopLeftRadius: "6px",
    borderTopRightRadius: "6px",
  })
);

export const TableTitle = styled("span")(({ theme }) => ({
  fontWeight: 500,
  fontSize: "14px",
}));

// Filter row container
export const FilterContainer = styled(Grid)(({ theme }) => ({
  padding: theme.spacing(0, 3),
}));

// Search field paper
export const SearchPaper = styled(Paper)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  width: "100%",
  border: "1px solid #ECEBEB",
  boxShadow: "none",
  height: 44,
  padding: theme.spacing(0, 1),
}));

// Table cell base style
export const StyledTableCell = styled(TableCell)(({ theme }) => ({
  fontSize: "14px",
  fontWeight: "500",
  whiteSpace: "nowrap",
  padding: "16px",
  overflow: "hidden",
  textOverflow: "ellipsis",
  "&:first-of-type": {
    paddingLeft: "24px",
  },
  "&:last-child": {
    paddingRight: "24px",
  },
}));

// Table header cell
export const HeaderCell = styled(StyledTableCell)(({ theme }) => ({
  position: "sticky",
  top: 0,
  backgroundColor: "#BE89763D",
  zIndex: 1,
}));

// Table body cell
export const BodyCell = styled(StyledTableCell)(({ theme }) => ({
  color: "#566166",
}));

// Table container
export const StyledTableContainer = styled(TableContainer)(({ theme }) => ({
  borderBottomLeftRadius: "6px",
  borderBottomRightRadius: "6px",
  borderTopRightRadius: 0,
  borderTopLeftRadius: 0,
  overflowX: "auto",
}));

// Table
export const StyledTable = styled(Table)(({ theme }) => ({
  minWidth: 900,
  width: "100%",
}));

// Filter form control
export const FilterFormControl = styled(FormControl)(({ theme }) => ({
  width: "100%",
  "& .MuiInputLabel-root": {
    fontSize: "15px",
    color: "rgb(86, 97, 102)",
    fontWeight: "400",
    "&.Mui-focused": {
      color: "#BE8976",
    },
  },
  "&.Mui-focused": {
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "#BE8976",
    },
  },
}));

// Select
export const StyledSelect = styled(Select)(({ theme }) => ({
  height: "44px",
  fontSize: "14px",
  color: "rgb(86, 97, 102)",
  fontWeight: "400",
}));

// Menu item
export const StyledMenuItem = styled(MenuItem)(({ theme }) => ({
  fontSize: "14px",
  color: "rgb(86, 97, 102)",
  fontWeight: "400",
  "&.Mui-selected": {
    background: "#BE8976 !important",
    color: "#fff !important",
  },
}));

// Vertical divider for filter row
export const VerticalDivider = styled(Divider)(({ theme }) => ({
  height: 44,
  margin: theme.spacing(0, 2),
}));

// (Optional) Section/action containers if you want to merge from your minimal file:
export const AppTableSectionContainer = styled("div")(() => ({
  display: "flex",
  justifyContent: "space-between",
  padding: "20px 16px",
  alignItems: "center",
  gap: "20px",
}));

export const AppTableActionContainer = styled("div")(() => ({
  display: "flex",
  flexDirection: "row",
  gap: "16px",
  alignItems: "center",
}));

export const ContainerHeader = styled(Box)(
  ({ theme, p = "10px", height = "2rem" }) => ({
    padding: p,
    backgroundColor: "white",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    height: height,
    borderTopLeftRadius: "6px",
    borderTopRightRadius: "6px",
  })
);
